import { format, isToday } from "date-fns";

export function formatDateTime(date: Date) {
  if (isToday(date)) {
    return format(date, "HH:mm");
  } else {
    return format(date, "yyyy-MM-dd HH:mm");
  }
}
